module.exports = __webpack_public_path__ + "img/img_thumb_0201.4574aeaf.png";